class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-sticky-atc-button]');
    this.buttonLabel = this.querySelector('[data-sticky-button-label]');
    this.price = this.querySelector('[data-sticky-price]');
    this.mainForm = document.querySelector('product-form form');
    this.mainBuyButton = document.querySelector('[data-buy-button]');
    
    this.threshold = 400; // Pixels scrolled before showing sticky bar
    this.bottomOffset = 80; // Hide when this close to the page bottom so the footer stays uncovered
    this.isVisible = false;
    
    if (this.button) {
      this.button.addEventListener('click', this._onAddToCart.bind(this));
    }
    
    // Listen to scroll events
    this._onScroll = this._handleScroll.bind(this);
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll, { passive: true });
    
    // Listen to variant changes
    document.addEventListener('product:variant:change', this._onVariantChange.bind(this));
    
    // Listen to cart:added to handle success
    document.addEventListener('cart:added', this._onCartAdded.bind(this));
    
    // Initial check
    this._handleScroll();
  }
  
  _handleScroll() {
    const scrolled = window.pageYOffset || document.documentElement.scrollTop;
    const atPageBottom = scrolled + window.innerHeight >= document.documentElement.scrollHeight - this.bottomOffset;
    const shouldShow = scrolled > this.threshold && !atPageBottom;
    
    // Check if main buy button is in viewport
    if (this.mainBuyButton) {
      const rect = this.mainBuyButton.getBoundingClientRect();
      const isMainButtonVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
      
      // Only show sticky bar if scrolled past threshold AND main button is not visible
      if (shouldShow && !isMainButtonVisible && !this.isVisible) {
        this.hidden = false;
        this.isVisible = true;
        requestAnimationFrame(() => {
          this.classList.add('is-visible');
        });
      } else if ((!shouldShow || isMainButtonVisible) && this.isVisible) {
        this.classList.remove('is-visible');
        this.isVisible = false;
        setTimeout(() => {
          if (!this.isVisible) {
            this.hidden = true;
          }
        }, 300); // Match CSS transition duration
      }
    }
  }
  
  async _onAddToCart(e) {
    e.preventDefault();
    
    if (this.button.disabled || this.button.classList.contains('is-loading')) {
      return;
    }
    
    const variantId = this.button.dataset.variantId;
    if (!variantId) return;
    
    this.button.classList.add('is-loading');
    this.button.disabled = true;
    
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || this.dataset.labelError || 'Could not add product');
      }
      
      // Dispatch cart:added event to trigger cart drawer
      document.dispatchEvent(new CustomEvent('cart:added'));
      
    } catch (error) {
      alert(error.message);
      this.button.classList.remove('is-loading');
      this.button.disabled = false;
    }
  }
  
  _onCartAdded() {
    // Remove loading state after cart drawer opens
    setTimeout(() => {
      this.button.classList.remove('is-loading');
      this.button.disabled = false;
    }, 300);
  }
  
  _onVariantChange(e) {
    const variant = e.detail && e.detail.variant;
    if (!variant) {
      this.button.disabled = true;
      if (this.buttonLabel) {
        this.buttonLabel.textContent = this.dataset.labelUnavailable || 'Unavailable';
      }
      return;
    }
    
    // Update button state
    this.button.disabled = !variant.available;
    this.button.dataset.variantId = variant.id;
    
    if (this.buttonLabel) {
      this.buttonLabel.textContent = variant.available
        ? (this.dataset.labelAdd || 'Add to cart')
        : (this.dataset.labelSoldOut || 'Sold out');
    }
    
    // Update price
    if (this.price) {
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';
      const formatted = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      }).format(variant.price / 100);
      
      this.price.textContent = formatted;
    }
  }
  
  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onScroll);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
